module.exports = __webpack_public_path__ + "static/img/547.c98c33b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/547.png
// module id = 395
// module chunks = 12 14